import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

const EffortlesslyMaintainMetadata = ({ onLearnMoreClick }) => {
  return (
    <div className="effortlessly-maintain-metadata">
      <div className="container">
        {/* <div className="pt--60"> */}
        <div className="row pt--60 pb--60">
          <div className="col-lg-6">
            <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
              <h2>Effortlessly maintain metadata</h2>
              <h4>Fix metadata that is incomplete or inaccurate.</h4>
              <div className="mt--40">
                <p className="font--20">
                  Noctil’s platform acts as an extension of your existing investment to
                  protect your metadata from inconsistent, non-authoritative, and
                  duplicate data.
                </p>
                <p className="font--20">
                  You can transform data into various formats or enrich your metadata with
                  rules and run complex distribution calculations effortlessly with our
                  AI/ML-powered system.
                </p>
                <p className="font--20">
                  Integrate any data sources effortlessly into your system.
                </p>
                <p className="font--20">Unlock the hidden value in your metadata.</p>
              </div>
              <div className="mt--40">
                <div>
                  <button
                    className="custom-btn"
                    onClick={() => {
                      onLearnMoreClick();
                    }}
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </ScrollAnimation>
          </div>
          <div className="col-lg-6 text-center">
            <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={200}>
              <img
                src="/assets/images/matchiq/noctil-platform-integration-no-bg.png"
                alt="Organize and fix metadata that is incomplete or inaccurate."
                style={{
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                }}
              />
            </ScrollAnimation>
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default EffortlesslyMaintainMetadata;
